import * as yup from 'yup';
import cloneDeep from 'lodash/cloneDeep'
import assign from 'lodash/assign'
import merge from 'lodash/merge'	
import { getAccountDefaults } from '@modules/account/account.module'
import jobStatuses from '@server/constants/statuses/job-statuses'

import UseAccount from '@connects/account'
import createSingularContainer from '@components/Singular/createSingularContainer'
import { UserModel } from '@modules/user/user.module'

UserModel.startFieldBuffer();

const formConfig = [
	{
		label: "Primary Login E-mail",
		fields: UserModel.getFieldProps([
			['email', {
				label: '',
			}],
		]),
	},
	{
		label: 'Update password',
		fields: UserModel.getFieldProps([
			'password',
			'passwordConfirm'
		])
	},
];

const fieldPaths = UserModel.endFieldBuffer();

export default createSingularContainer({
	title: 'Account Settings',
	connect: UseAccount(),
	resource: 'account',
	editOnly: true,
	formConfig,
	mapPropsToValues: props => {
		var data = cloneDeep(props.data);
		// TODO: use UserModel here
		return merge(getAccountDefaults(), data);
	},
	validationSchema: UserModel.getValidationSchema(fieldPaths, { strictMode: true, includePrivate: true, isNew: false }),
	createdString: 'Account created',
});




// WEBPACK FOOTER //
// ./src/scenes/Account/AccountContainer.jsx